import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import findOnePaymentNotice from "./actions/findOnePaymentNotice";
import findPendingInvoicesByClientIdentifier from "./actions/findPendingInvoicesByClientIdentifier";
import { Archive } from "../../@types/archive";
import createArchive from "./actions/createArchive";
import deleteArchive from "./actions/deleteArchive";
import findPaymentNoticeMessages from "./actions/findPaymentNoticeMessages";
import sendMessage from "./actions/sendMessage";
import { Message } from "../../@types/message";
import { Account } from "../../@types/account";
import { PaymentNotice } from "../../@types/paymentNotice";

interface PaymentNoticeDetailState {
  paymentNotice: PaymentNotice;
  itemMessageFormData: {
    text: string;
    archives: Archive[];
  };
  deleteArchiveStatus: string;
  itemMessages: Message[];
  findMessagesStatus: string;
  sendMessageStatus: string;
  viewSegmentSelected: string;
  accountSelected?: Account;
  clientSelectorSearchText: string;
}

const initialState = {
  paymentNotice: {},
  itemMessageFormData: {
    text: "",
    archives: [],
  },
  deleteArchiveStatus: "",
  itemMessages: [],
  findMessagesStatus: "",
  sendMessageStatus: "",
  viewSegmentSelected: "info",
  accountSelected: undefined,
  clientSelectorSearchText: "",
} as PaymentNoticeDetailState;

const paymentNoticeDetailSlice = createSlice({
  name: "paymentNoticeDetail",
  initialState,
  reducers: {
    updateClientSelectorSearchText(state, action: PayloadAction<string>) {
      state.clientSelectorSearchText = action.payload || "";
    },
    setPaymentNotice(state, action: PayloadAction<object>) {
      state.paymentNotice = {
        ...state.paymentNotice,
        ...action.payload,
      };
    },
    updateItemMessageText(state, action) {
      state.itemMessageFormData.text = action.payload;
    },
    setViewSegmentSelected(state, action) {
      state.viewSegmentSelected = action.payload;
    },
    setAccountSelected(state, action) {
      state.accountSelected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      /***
       * findOnePaymentNotice
       */
      .addCase(findOnePaymentNotice.pending, (state, { payload }) => {
        state.itemMessages = [];
        state.itemMessageFormData = {
          text: "",
          archives: [],
        };
      })
      .addCase(findOnePaymentNotice.fulfilled, (state, { payload }) => {
        state.paymentNotice = {
          ...state.paymentNotice,
          ...payload,
        };
      })
      .addCase(findOnePaymentNotice.rejected, (state, { payload }) => {})
      /**
       * findPendingInvoicesByClientIdentifier
       */
      /*       .addCase(
        findPendingInvoicesByClientIdentifier.fulfilled,
        (state, { payload }) => {
          if (state.paymentNoticesCreateFormDataItem.client) {
            state.paymentNoticesCreateFormDataItem.client.invoices = payload;
          }
        }
      ) */
      /***
       * createArchive
       */
      .addCase(createArchive.fulfilled, (state, { payload }) => {
        state.itemMessageFormData.archives = [
          ...state.itemMessageFormData.archives,
          payload,
        ];
      })
      /**
       * deleteArchive
       */
      .addCase(deleteArchive.pending, (state, { payload }) => {
        state.deleteArchiveStatus = "pending";
      })
      .addCase(deleteArchive.fulfilled, (state, { payload }) => {
        state.itemMessageFormData = {
          ...(state.itemMessageFormData || {}),
          archives: state.itemMessageFormData.archives.filter(
            (archive) => archive.id !== payload.id
          ),
        };
        state.deleteArchiveStatus = "fulfilled";
      })
      .addCase(deleteArchive.rejected, (state, { payload }) => {
        state.deleteArchiveStatus = "rejected";
      })
      /**
       * findPaymentNoticeMessages
       */
      .addCase(findPaymentNoticeMessages.pending, (state, { payload }) => {
        state.findMessagesStatus = "pending";
      })
      .addCase(findPaymentNoticeMessages.fulfilled, (state, { payload }) => {
        state.itemMessages = payload;
        state.findMessagesStatus = "fulfilled";
      })
      .addCase(findPaymentNoticeMessages.rejected, (state, { payload }) => {
        state.findMessagesStatus = "rejected";
      })
      /**
       * sendMessage
       */
      .addCase(sendMessage.pending, (state, { payload }) => {
        state.sendMessageStatus = "pending";
      })
      .addCase(sendMessage.fulfilled, (state, { payload }) => {
        state.sendMessageStatus = "fulfilled";
        state.itemMessages.unshift(payload);
        state.itemMessageFormData = {
          text: "",
          archives: [],
        };
      })
      .addCase(sendMessage.rejected, (state, { payload }) => {
        state.sendMessageStatus = "rejected";
      });
  },
});

export const paymentNoticeDetail = paymentNoticeDetailSlice.reducer;
